import { BRAND_COLORS } from "@/components/landing/StoreCustomizer/config";

interface ColorPickerProps {
	label: string;
	colorId: (typeof BRAND_COLORS)[number]["id"];
	onChange: (id: (typeof BRAND_COLORS)[number]["id"]) => void;
}

function ColorPicker(prop: ColorPickerProps) {
	const { label, colorId, onChange } = prop;
	return (
		<div>
			<p className="mb-2.5 text-xs font-semibold text-muted-foreground">{label}</p>
			<div role="radiogroup" aria-label={label} className="flex gap-2.5">
				{BRAND_COLORS.map((c) => {
					const isActive = c.id === colorId;
					return (
						<button
							key={c.id}
							type="button"
							role="radio"
							aria-checked={isActive}
							aria-label={c.id}
							onClick={() => onChange(c.id)}
							className="h-6 w-6 shrink-0 rounded-full transition-transform"
							style={{
								background: c.hex,
								boxShadow: isActive ? `0 0 0 2px var(--surface), 0 0 0 4px ${c.hex}` : "none",
								transform: isActive ? "scale(1.05)" : "scale(1)",
							}}
						/>
					);
				})}
			</div>
		</div>
	);
}

export default ColorPicker;
